module.exports = __webpack_public_path__ + "static/ISO-logo-3d50d5b1c22d2710b25fab18a125acd1.png";